import { CobaltPageHeader } from '@cae/cobalt-react/components/page-header';
import { useAuthenticatedUser } from '@contexts/auth-provider/hooks/use-authenticated-user/useAuthenticatedUser';
import { useHasPermission } from '@contexts/permissions-provider';
import { AccessPassWidget } from '@features/access-passes/visitor-access-pass/access-pass-widget/AccessPassWidget';
import { CustomerCareTile } from '@features/home/components/for-you/customer-care-tile/CustomerCareTile';
import { getSalutation } from '@shared/helpers/get-salutation/getSalutation';
import * as React from 'react';

import styles from './CommonHomeContent.module.css';
/**
 * CommonHomeContent - Home page content for users without modules
 *
 * Shown when:
 * - User has no modules (Visitor)
 * - selectedModule is null/undefined
 *
 * Current use case:
 * - Visitor: Just registered, no training yet
 */
const CommonHomeContent = React.memo((): React.ReactElement => {
  const authData = useAuthenticatedUser();
  const salutation = React.useMemo(() => getSalutation(), []);
  const canViewCustomerCare = useHasPermission('HelpBasic_View_Any');

  return (
    <div
      data-testid="common-home-content-page"
      className={styles.commonHomeContentPage}
    >
      <CobaltPageHeader
        title={`${salutation}, ${authData.firstName}`}
        subtitle="Welcome to CAE Connect, your partner in your training journey."
        className={styles.commonHomeContentHeader}
      />
      <div
        data-testid="common-home-content"
        className={styles.commonHomeContent}
      >
        <AccessPassWidget />
        {canViewCustomerCare && <CustomerCareTile />}
      </div>
    </div>
  );
});

CommonHomeContent.displayName = 'CommonHomeContent';
export { CommonHomeContent };
